<template>
  <div class="video-screen" v-if="!isFullScreen">
    <van-loading v-if="video.videoisLoading" class="ab-center" type="spinner" color="#fff" />
    <div v-else @click="showControlBar" class="has-url">
      <div v-if="!video.videoisPlaying" class="video-control-bar">
        <i @click="videoControl(true)" class="iconfont iconicon_play"></i>
        <van-slider
          :step="0.1"
          @drag-start="dragStart"
          @change="dragChange"
          @drag-end="dragEnd"
          :max="videoDuration"
          style="margin: 0 20px"
          v-model="videoTime"
          button-size="12px"
        />
        <i @click="testFull" class="iconfont iconquanping1"></i>
      </div>
      <transition name="van-fade" v-else>
        <div class="video-control-bar" v-show="controlBarShow">
          <i @click="videoControl(false)" class="iconfont iconzanting"></i>
          <van-slider
            :step="0.1"
            @drag-start="dragStart"
            @change="dragChange"
            @drag-end="dragEnd"
            :max="videoDuration"
            style="margin: 0 20px"
            v-model="videoTime"
            button-size="12px"
          />
          <i @click="testFull" class="iconfont iconquanping1"></i>
          <!-- <i @click="handle2FullScreen" class="iconfont iconquanping1"></i> -->
        </div>
      </transition>
      <!-- <i @click="videoControl(true)" v-if="!video.videoisPlaying" class="iconfont icon-video ab-center"></i>
      <transition name="van-fade" v-else>
        <div class="ab-center" v-show="controlBarShow">
          <i @click="videoControl(false)" class="iconfont iconzanting"></i>
        </div>
      </transition> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ['videoDuration', 'videoCurrent'],
  computed: {
    video() {
      return this.$store.state.activePlay.video
    },
    isFullScreen() {
      return this.$store.state.activePlay.isFullScreen
    }
  },
  watch: {
    videoCurrent(val) {
      if (!this.isDraging) {
        this.videoTime = val
      }
    }
  },
  data() {
    return {
      controlBarShow: false,
      videoTime: 0,
      isDraging: false
    }
  },
  methods: {
    showControlBar() {
      this.controlBarShow = true
      this.set3sHide()
    },
    set3sHide() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.controlBarShow = false
      }, 3000)
    },
    videoControl(flag) {
      this.$emit('videoPlayOrPause', flag)
    },

    testFull() {
      const mainPlayerContainer = document.getElementById('videoContainer')
      const w = document.documentElement.clientWidth || document.body.clientWidth
      const h = document.documentElement.clientHeight || document.body.clientHeight
      const cha = Math.abs(h - w) / 2
      if (!mainPlayerContainer) return
      if (!this.isFullScreen) {
        mainPlayerContainer.style.width = h + 'px'
        mainPlayerContainer.style.height = w + 'px'
        mainPlayerContainer.style.zIndex = '98'
        mainPlayerContainer.style.transform = 'translate(-' + cha + 'px,' + cha + 'px) rotate(90deg)'
      } else {
        mainPlayerContainer.style.width = ''
        mainPlayerContainer.style.height = ''
        mainPlayerContainer.style.zIndex = ''
        mainPlayerContainer.style.transform = ''
      }
      this.$store.commit('toggleFullScreen')
      this.$emit('restScreen', this.isFullScreen)
    },
    handle2FullScreen() {
      /* bilibili 全屏 */
      // this.$store.commit('controlVideo', {isFullScreen: !this.video.isFullScreen})
      // this.$nextTick(() => {
      //   this.$emit('restScreen')
      // })
      /* 系统全屏 */
      const ele = document.getElementById('videoElement')
      if (ele.requestFullscreen) {
        ele.requestFullscreen()
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen()
      } else if (ele.webkitRequestFullScreen) {
        ele.webkitRequestFullScreen()
      } else if (ele.webkitEnterFullScreen) {
        ele.webkitEnterFullScreen()
      }
    },
    dragStart() {
      this.isDraging = true
    },
    dragChange(value) {
      this.$emit('videoCurrentTimeChange', value)
    },
    dragEnd() {
      this.$emit('videoCurrentTimeChange', this.videoTime)
      this.isDraging = false
    }
  }
}
</script>

<style scoped lang="scss">
.video-screen {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.has-url {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
}

// i {
//   color: #fff;
//   font-size: 60px;
//   z-index: 101;
// }

.video-control-bar {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 100;
  width: 100%;
  height: 40px;
  background: rgba(0, 0, 0, 0.2);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  i {
    color: #fff;
    font-size: 20px;
  }
}
</style>
